import { visitServiceApi } from "../../app/visitServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { GetQueryArgsType } from "../../types";
import {
  EmployeeTrackingAlternativeResponseType,
  EmployeeTrackingDataResponseType,
  EmployeeTrackingParams,
  GetEmployeeTrackingDateListResponseType,
  GetEmployeeTrackingHistoryParams,
  GetEmployeeTrackingHistoryResponseType,
} from "../../types/tracking";

export const employeeTracking = visitServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmployeeTrackingData: builder.query<
      EmployeeTrackingDataResponseType,
      GetQueryArgsType<EmployeeTrackingParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getEmployeeTrackingData,
        ...queryArgs,
      }),
    }),
    getEmployeeTrackingAlternative: builder.query<
      EmployeeTrackingAlternativeResponseType,
      GetQueryArgsType<EmployeeTrackingParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getEmployeeTrackingAlternative,
        ...queryArgs,
      }),
    }),
    getEmployeeTrackingHistory: builder.query<
      GetEmployeeTrackingHistoryResponseType,
      GetQueryArgsType<GetEmployeeTrackingHistoryParams>
    >({
      query: ({ params }) => ({
        url: `${API_URL.getEmployeeTrackingHistory}/${params?.id}`,
        params: {
          date: params?.date,
        },
      }),
    }),
    getEmployeeTrackingDateList: builder.query<
      GetEmployeeTrackingDateListResponseType,
      string
    >({
      query: (id) => ({
        url: `${API_URL.getEmployeeTrackingDateList}/${id}`,
      }),
    }),
    bariKoiApiHit: builder.mutation<void, void>({
      query: () => ({
        url: API_URL.bariKoiApiHit,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetEmployeeTrackingDataQuery,
  useGetEmployeeTrackingAlternativeQuery,
  useGetEmployeeTrackingHistoryQuery,
  useGetEmployeeTrackingDateListQuery,
  useBariKoiApiHitMutation,
} = employeeTracking;
